import { captureException } from '@sentry/react';
import createCollectionResource from 'src/actions/shared/createResource';
import { CustomAttribute } from './customAttribute';
import { DomainError } from 'src/models/DomainError';
import { FIELD_LABEL_DELIMITER, translateJoiErrors } from 'src/actions/shared/validationHelpers';
import { getCustomAttributesSchema } from './validation/schemas';
import { ValidateItemIsNotDuplicate } from './validateItemIsNotDuplicate';
import analytics from '@ad-scripts/lib/analytics';

const customAttributesResource = createCollectionResource<CustomAttribute>({
  name: 'customAttributes',
  endpoint: 'v1/orgs/:orgId/custom-attributes/:id',
  observerCreator: ({ actions }) => {
    return ({ dispatch }) => {
      return {
        onBroadcast(item) {
          dispatch(actions.broadcast(item));
        },
      };
    };
  },
  options: {
    toastMessages: {
      onAdd: () => 'Custom Attribute created',
      onUpdate: () => 'Custom Attribute updated',
    },
  },
  type: CustomAttribute,
});

customAttributesResource.effects.validateItem = (item: CustomAttribute, knownErrors?: DomainError[]) => dispatch => {
  const schema = getCustomAttributesSchema();
  try {
    const combinedErrors = knownErrors ? [...knownErrors] : [];
    const { error } = schema.validate(item, {
      abortEarly: false,
      allowUnknown: true,
      skipFunctions: true,
      errors: {
        label: false,
        wrap: {
          label: FIELD_LABEL_DELIMITER,
        },
      },
    });
    if (error) {
      const newErrors = translateJoiErrors(error);
      combinedErrors.push(...newErrors);
    }

    combinedErrors.push(...ValidateItemIsNotDuplicate(item));

    if (combinedErrors.length) {
      dispatch(customAttributesResource.actions.validationError(combinedErrors));
      analytics.track('Custom Attribute Validation Error', {
        errors: combinedErrors,
      });
      return false;
    } else {
      return true;
    }
  } catch (err) {
    // If we are here, it is likely a bug in Joi. Log a sentry
    captureException(err, { tags: { originalItem: JSON.stringify(item, null, 2) } });
    return false;
  }
};

export default customAttributesResource;
